module.exports = __webpack_public_path__ + "static/media/allium_logo.69c57dbe.svg";